import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

const ADDITIONAL_AMENITIES_SKELETON_SECTIONS_COUNT = 2
const ADDITIONAL_AMENITIES_SKELETON_FIELDS_COUNT = 3

export const AdditionalAmenitiesStepSkeleton = () => (
  <>
    {Array.from({ length: ADDITIONAL_AMENITIES_SKELETON_SECTIONS_COUNT }).map(
      (_, sectionIndex) => (
        <div
          key={sectionIndex}
          className={s.section}
        >
          <Skeleton
            width="48%"
            height={24}
            borderRadius={6}
          />

          {Array.from({
            length: ADDITIONAL_AMENITIES_SKELETON_FIELDS_COUNT,
          }).map((__, fieldIndex) => (
            <Skeleton
              key={fieldIndex}
              className={s.field}
            />
          ))}
        </div>
      ),
    )}
  </>
)
